import styled from 'styled-components';
import { colors, typography } from '../../../styles/theme';

// Content Layout Components
export const ContentSection = styled.div`
  background: white;
  border-radius: 16px;
  padding: 32px;
  margin-bottom: 24px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.02);
`;

export const SectionTitle = styled.h2`
  font-family: ${typography.fontFamily};
  font-size: ${typography.fontSize.lg};
  color: ${colors.text.primary};
  margin: 0 0 24px 0;
  font-weight: ${typography.fontWeight.medium};
`;

export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
  margin-bottom: 24px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const InfoCard = styled.div`
  background: white;
  padding: 24px;
  border-radius: 12px;
  border: 0px solid rgba(0, 0, 0, 0.05);
  transition: all 0.2s ease;
  ${props => props.withActions ? 'display: flex; align-items: flex-start;' : ''}

  &:hover {
    transform: translateY(-1px);
    background-color: rgba(0, 0, 0, 0.03);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.05);
  }
`;

export const InfoLabel = styled.div`
  font-family: ${typography.fontFamily};
  font-size: ${typography.fontSize.sm};
  color: ${colors.text.secondary};
  margin-bottom: 16px;
  font-weight: ${typography.fontWeight.medium};
`;

export const InfoValue = styled.div`
  font-family: ${typography.fontFamily};
  font-size: ${typography.fontSize.base};
  color: ${colors.text.primary};
  font-weight: ${typography.fontWeight.medium};
  line-height: 1.5;
`;

export const EmptyState = styled.div`
  font-family: ${typography.fontFamily};
  font-size: ${typography.fontSize.base};
  color: ${colors.text.secondary};
  text-align: left;
  padding: 32px;
  background: ${colors.background.light};
  border-radius: 8px;
`;

export const Tag = styled.span`
  padding: 4px 12px;
  border-radius: 16px;
  font-size: ${typography.fontSize.sm};
  background: ${props => props.background || colors.accent + '20'};
  color: ${props => props.color || colors.primary};
`; 